import * as React from 'react';
import { useSelectionListItemContext } from '../../hooks/useSelectionListItemContext.js';
import '../../../../../Typography/index.js';
import { Typography } from '../../../../../Typography/Typography.js';

var SelectionListItemTitle = /*#__PURE__*/React.memo(function (props) {
  var lineClamp = props.lineClamp,
    children = props.children;
  var _useSelectionListItem = useSelectionListItemContext(),
    isSelected = _useSelectionListItem.isSelected,
    isDisabled = _useSelectionListItem.isDisabled;
  return /*#__PURE__*/React.createElement(Typography, {
    variant: isSelected ? 'body-default-strong' : 'body-default',
    textColor: isDisabled ? 'state.disabled' : 'base.default',
    lineClamp: lineClamp
  }, children);
});

export { SelectionListItemTitle };
//# sourceMappingURL=SelectionListItemTitle.js.map
